import { render, staticRenderFns } from "./StandardColorPicker.vue?vue&type=template&id=4046e0f8"
import script from "./StandardColorPicker.vue?vue&type=script&lang=js"
export * from "./StandardColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports